import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BoutonOnglet from "./BoutonOnglet";
import ModalAcompte from "./ModalAcompte";

const FactureModal = ({ visible, onClose, onSelectType, devis }) => {



  const [showAcompteModal, setShowAcompteModal] = useState(false);
  const navigate = useNavigate();
  const [mode, setMode] = useState("percent");
  const [value, setValue] = useState("");
  const handleRedirect = (type) => {
    if (type === "acompte") {
      navigate(`/facture-acompte?devisId=${onSelectType}`);
    } else {
      onSelectType(type);
    }
  };



  if (!visible) return null;

  const handleValiderAcompte = ({ mode, value }) => {
    // Redirection avec params
    navigate(`/facture-acompte?devisId=${devis._id}&acompteMode=${mode}&acompteValue=${value}`);
  };

  return (
    <div className="modal-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="modal-content bg-white p-6 rounded shadow-md w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4">Quel type de facture souhaitez-vous générer ?</h2>
        <div className="flex flex-col gap-2 items-w-full ">
          <BoutonOnglet actif={false} onClick={() => onSelectType("acompte")}>
            Facture d’acompte
          </BoutonOnglet>

          <BoutonOnglet actif={false} onClick={() => onSelectType('partielle')}>
            Facture partielle
          </BoutonOnglet>
          <BoutonOnglet actif={false} onClick={() => onSelectType?.("finale")}>
            Facture finale
          </BoutonOnglet>
        </div>

        <button onClick={onClose} className="mt-4 text-sm text-gray-600 underline  ">
          Annuler
        </button>
      </div>

      {/* Affiche le modal d’acompte si demandé */}
      {showAcompteModal && (
        <ModalAcompte
          devis={devis}
          totalHT={123} // ou calcule le totalHT si besoin
          totalTTC={456} // ou calcule le totalTTC si besoin
          onValider={handleValiderAcompte}
        />
      )}
    </div>
  );
};

export default FactureModal;
